import type { RedcatAnalyticsStore } from '../types/store';
import { SignupTrackEventName } from '../types/signup';
import type { SignupTrackEvent } from '../types/events/track';

export const trackSignupFailed = (
  track: RedcatAnalyticsStore['track'],
  {
    errorField,
    errorCode,
  }: {
    errorField: string | null;
    errorCode: string | number | null;
  },
) => {
  const event: SignupTrackEvent = {
    name: SignupTrackEventName.Failed,
    properties: {
      error_field: errorField,
      error_code: errorCode,
    },
  };

  track(event);
};
